import React from 'react'
import { Pannellum } from 'pannellum-react'

const Panaroma = props => (
  <div>
    <Pannellum
      autoLoad
      showControls={false}
      image={props.image}
    />
  </div>
)

export default Panaroma



// WEBPACK FOOTER //
// ./src/components/library/widgets/panorama/Panorama.js